var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { featureFlagClientInit } from '@raisin/feature-flag-react-client';
import { isAuthenticated } from '../auth';
import { getBACNumberFromJWT } from '../jwt';
import { buildFeatureFlagUser, getDefaultFFBuilderParams, getLaunchDarklyClientSideId, } from './clientBaseConfig';
import { getFeatureFlagConsentsData, getFeatureFlagUserData } from './requestData';
export const getFeatureFlagBuilderParams = () => __awaiter(void 0, void 0, void 0, function* () {
    if (!isAuthenticated())
        return getDefaultFFBuilderParams();
    const customerId = getBACNumberFromJWT() || '';
    const consentsParams = (yield getFeatureFlagConsentsData()) || {};
    const customerParams = yield getFeatureFlagUserData(customerId);
    return Object.assign(Object.assign(Object.assign({}, getDefaultFFBuilderParams()), consentsParams), customerParams);
});
export const getFeatureFlagClient = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const options = { streaming: true };
        const clientSideId = getLaunchDarklyClientSideId();
        const user = yield buildFeatureFlagUser(yield getFeatureFlagBuilderParams());
        const client = yield featureFlagClientInit(clientSideId, user, options);
        if (client)
            return client;
        throw Error();
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Failed initializing LaunchDarkly client.', error);
        return undefined;
    }
});
//# sourceMappingURL=customerConfig.js.map